import { getGamesStatsEndpoint } from 'root/src/server/modules/games/endpoints/getGamesStats.endpoint';
import { resetGamesStatsQuotaEndpoint } from 'root/src/server/modules/games/endpoints/resetGamesStatsQuota.endpoint';
export const gamesEndpoints = Object.assign(Object.assign({}, getGamesStatsEndpoint), resetGamesStatsQuotaEndpoint);
